import getStore from '../store/migrationSettingsDataStore';
import { MigrationSettingsDataType } from '../store/schema/migrationSettingsData';

export default function getMigrationSettingsUserInput(): MigrationSettingsDataType {
    return getStore().currentMigrationType;
}
